import React, { useEffect } from 'react';
import toastError from "../../errors/toastError";

import { Button, Divider, } from "@material-ui/core";

const LocationPreview = ({ image, link, description }) => {
    useEffect(() => {}, [image, link, description]);

    const getMapEmbedUrl = () => {
        const source = link || image || "";
        const coordinateMatch = source.match(/q=([^&]+)/);

        if (coordinateMatch?.[1]) {
            return `https://maps.google.com/maps?q=${coordinateMatch[1]}&z=17&output=embed`;
        }

        return "";
    }

    const mapEmbedUrl = getMapEmbedUrl();

    const handleLocation = async() => {
        try {
            window.open(link);
        } catch (err) {
            toastError(err);
        }
    }

    return (
		<>
			<div style={{
				minWidth: "250px",
				maxWidth: "330px",
				padding: "8px 8px 4px",
			}}>
				<div>
					<div>
						{mapEmbedUrl ? (
							<iframe
								src={mapEmbedUrl}
								title="Ubicacion"
								onClick={handleLocation}
								style={{
									width: "100%",
									height: "120px",
									border: 0,
									borderRadius: 8,
									display: "block",
								}}
								loading="lazy"
							/>
						) : (
							<img
								src={image}
								onClick={handleLocation}
								style={{
									width: "100%",
									height: "120px",
									objectFit: "cover",
									borderRadius: 8,
									display: "block",
								}}
								alt="Ubicacion"
							/>
						)}
					</div>
					{ description && (
					<div
						style={{
							fontSize: 15,
							fontWeight: 600,
							lineHeight: "20px",
							color: "#111b21",
							textAlign: "center",
							margin: "10px 8px 8px",
							overflowWrap: "anywhere",
						}}
						dangerouslySetInnerHTML={{ __html: description.replace('\\n', '<br />') }}
					>
					</div>
					)}
					<div style={{ display: "block", content: "", clear: "both" }}></div>
					<div>
						<Divider style={{ backgroundColor: "rgba(134, 150, 160, 0.25)" }} />
						<Button
							fullWidth
							color="primary"
							onClick={handleLocation}
							disabled={!link}
							style={{
								color: "#008069",
								fontSize: 13,
								fontWeight: 500,
								textTransform: "none",
								paddingTop: 8,
							}}
						>Visualizar</Button>
					</div>
				</div>
			</div>
		</>
	);

};

export default LocationPreview;
